import { DataBean } from "../../../DataBean";



export class HealthLOINC extends DataBean {


    public async getHealthLOINCCatalog(regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthLOINCCatalog_String_Number_Number", [regexStr,page,recordsPerPage]);
    }


}